export default {
  'feedback-module:did-pet-eat-product:title': 'Heeft je hond / je kat het product opgegeten?',
  'feedback-module:explanation:dog:subtitle':
    'Jouw feedback helpt ons het juiste voer voor je hond te vinden.',
  'feedback-module:explanation:cat:subtitle':
    'Jouw feedback helpt ons het juiste voer voor je kat te vinden.',
  'feedback-module:complete:title:thank-you': 'Hartelijk dank!',
  'feedback-module:complete:description':
    'We verwerken je antwoord voor beter passende voeraanbevelingen.',
  'feedback-module:button:no': 'Nee',
  'feedback-module:button:skip': 'Skip',
  'feedback-module:button:yes': 'Ja',
  'feedback-module:image:alt': 'Cat and dog cuddling',
};
